export const sitesWebMisc = {
  // NombreEditable.vue — inline-editable website name field
  ne: {
    aria: "Name Ihrer Website",
    placeholder: "Meine Unterkunft",
    hint: "Enter zum Speichern · Esc zum Abbrechen",
  },

  // website/index.vue — website creation wizard
  website: {
    next: "Weiter",
  },

  // Notificaciones/index.vue — notifications timeline
  notif: {
    title: "Benachrichtigungen",
    subtitle: "Alles, was in Ihren Unterkünften passiert ist, in chronologischer Reihenfolge.",
    // Filters
    filterAll: "Alle",
    filterBookings: "Buchungen",
    filterCheckins: "Check-ins",
    filterServices: "Services",
    filterPayments: "Zahlungen",
    // Empty state
    emptyAll: "Noch keine Benachrichtigungen",
    emptyFilter: "Keine Benachrichtigungen in diesem Filter",
    emptyBody:
      "Wenn bei Ihren Buchungen etwas passiert (eine neue Buchung, ein Check-in, eine Zahlung), erscheint es hier.",
    // Day separators
    noDate: "Kein Datum",
    today: "Heute",
    yesterday: "Gestern",
    // Event status (left column)
    stNueva: "Neu",
    stActualizada: "Aktualisiert",
    stCancelada: "Storniert",
    stRealizado: "Abgeschlossen",
    stSolicitado: "Angefragt",
    stRecibida: "Erhalten",
    stAprobada: "Genehmigt",
    stRechazada: "Abgelehnt",
    stConfirmado: "Bestätigt",
    stEnProceso: "Zahlung läuft",
    stAviso: "Hinweis",
    // Event category (subtitle)
    catReserva: "Buchung",
    catCheckin: "Check-in",
    catServicio: "Service",
    catSolicitud: "Anfrage",
    catPago: "Zahlung",
    catPagoPendiente: "ausstehende Zahlung",
    catSistema: "System",
    // Descriptive event-type labels
    lbNuevaReserva: "Neue Buchung",
    lbReservaActualizada: "Buchung aktualisiert",
    lbReservaCancelada: "Buchung storniert",
    lbCheckin: "Check-in",
    lbServicio: "Service",
    lbSolicitud: "Anfrage",
    lbSolicitudAprobada: "Anfrage genehmigt",
    lbSolicitudRechazada: "Anfrage abgelehnt",
    lbPago: "Zahlung",
    lbNotificacion: "Benachrichtigung",
  },

  // Integrations/index.vue — integrations with external services
  integrations: {
    title: "Integrationen",
    subtitle: "Externe Dienste verbinden, um die Verwaltung zu vereinfachen",
    descPricelabs: "Dynamische Preisoptimierung",
    descStripe: "Kartenzahlungen von Gästen",
    descWompi: "Gästezahlungen in Kolumbien",
    connected: "Verbunden",
    disconnected: "Nicht verbunden",
  },
};
